import { configureStore } from '@reduxjs/toolkit';
import localReducer from './slices/localSlice';
import participantsReducer from './slices/participantsSlice';
import conferenceReducer from './slices/conferenceSlice';
import audioIndicatorReducer from './slices/audioIndicatorSlice';
import mainUserReducer from './slices/mainUserSlice';
import screenShareReducer from './slices/screenShareSlice';
import floorReducer from './slices/floorSlice';
import chatReducer from './slices/chatSlice';
import recordingReducer from './slices/recordingSlice';
import drawingReducer from './slices/drawingSlice';
import documentShareReducer from './slices/documentShareSlice';
import captionReducer from './slices/captionSlice';
import virtualBackgroundReducer from './slices/virtualBackgroundSlice';
import voiceNoteReducer from './slices/voiceNoteSlice';
import uiReducer from './slices/uiSlice';
import masterReducer from './slices/masterSlice';
import whiteboardReducer from './slices/whiteboardSlice';
import emojiReducer from './slices/emojiSlice';
import notificationReducer from './slices/notificationSlice';
import toastReducer from './slices/toastSlice';
import translationReducer from './slices/translationSlice';

export const store = configureStore({
  reducer: {
    local: localReducer,
    participants: participantsReducer,
    conference: conferenceReducer,
    audioIndicator: audioIndicatorReducer,
    mainUser: mainUserReducer,
    screenShare: screenShareReducer,
    floor: floorReducer,
    chat: chatReducer,
    recording: recordingReducer,
    drawing: drawingReducer,
    documentShare: documentShareReducer,
    caption: captionReducer,
    virtualBackground: virtualBackgroundReducer,
    voiceNote: voiceNoteReducer,
    ui: uiReducer,
    master: masterReducer,
    whiteboard: whiteboardReducer,
    emoji: emojiReducer,
    notification: notificationReducer,
    toast: toastReducer,
    translation: translationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // JitsiLocalTrack 같은 non-serializable 객체는 Redux 밖에서 관리하므로
      // 직렬화 불가 경고 대상을 최소화
      serializableCheck: {
        // MediaDeviceInfo (DOM 객체)는 Redux에 직렬화 불가하지만 허용
        ignoredPaths: [
          'local.audioInputDevices',
          'local.videoInputDevices',
          'local.audioOutputDevices',
        ],
        ignoredActionPaths: [
          'payload.audioInputDevices',
          'payload.videoInputDevices',
          'payload.audioOutputDevices',
          'payload.devices',
        ],
      },
    }),
  devTools: import.meta.env.DEV,
});

// Debug: expose store to window for testing
if (import.meta.env.DEV) {
  (window as any).__REDUX_STORE__ = store;

  // 레이아웃 테스트용 가상 참가자 도구
  import('@/utils/devTools').then(({ installDevTools }) => installDevTools());
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
